export default "__VITE_ASSET__wyW9it4z__"